// extracted by mini-css-extract-plugin
export default {"card":"BZ-z","carouselContainer":"CZ-z","carouselContent":"DZ-z"};